import React from 'react'
import { formatDate } from '../../../utils/date'
import { signerEvidenceLines } from './signerEvidence'
import SignatureAuditDownload from './SignatureAuditDownload'

export default function SignatureHistory({ enabled = false, history = [], onDownload }) {
  if (!enabled || !history.length) return null

  return <section className="flex flex-col gap-3">
    <h4 className="text-text-primary text-[14px] font-bold">Previous signatures</h4>
    {history.map((event, index) => <div key={`${event.key}-${index}`} className="flex flex-col gap-2">
      {(event.signers || []).filter((signer) => signer.signed).map((signer, signerIndex) => <div key={signerIndex} className="flex flex-col gap-1">
        <span>{signer.email || 'N/A'} - {signer.signedAt ? formatDate(signer.signedAt) : 'N/A'}</span>
        {signerEvidenceLines(signer).map(([label, value]) => <span key={label} className="flex gap-2">
          <span className="text-text-secondary min-w-[80px]">{label}</span><span>{value}</span>
        </span>)}
      </div>)}
      <button type="button" className="text-primary-main underline text-left" onClick={() => onDownload({ key: event.key })}>
        Download previous signed PDF
      </button>
      <SignatureAuditDownload enabled={enabled} audit={event.signatureAudit} onDownload={onDownload} previous />
    </div>)}
  </section>
}
